const clean = (value) => String(value || '').trim();

export const buildContextualFollowUps = (query, context = {}) => {
    const normalized = clean(query).toLowerCase();
    const controlTitle = clean(context.control?.title);
    const unanswered = (context.questions || []).filter(question => !clean(question.response));

    if (normalized.includes('summarize') || normalized.includes('summary')) {
        return [
            unanswered.length
                ? `Which unanswered question should I address first for ${controlTitle || 'this control'}?`
                : `What should I improve next for ${controlTitle || 'this control'}?`,
            `What evidence should I collect for ${controlTitle || 'this control'}?`,
            `Explain the main compliance risk for ${controlTitle || 'this control'}.`,
        ];
    }

    if (normalized.includes('evidence')) {
        return [
            'Give me specific examples of acceptable evidence.',
            'Which evidence gaps are highest priority?',
            'How should I document this evidence for an assessor?',
        ];
    }

    return [
        `What does ${controlTitle || 'this control'} require in practical terms?`,
        `What evidence demonstrates compliance with ${controlTitle || 'this control'}?`,
        `What are the next steps to complete ${controlTitle || 'this control'}?`,
    ];
};

export const normalizeAssistantMarkdown = (value) => {
    return clean(value)
        .replace(/\s+\*\s+\*\*(Q\d+):\*\*/gi, '\n- **$1:**')
        .replace(/\s+\*\*((?!Q\d+:)[^*:\n]{2,50}):\*\*/gi, '\n\n**$1:**')
        .replace(/\s+\*\s+(?=[A-Z0-9])/g, '\n- ')
        .replace(/^\*\s+/gm, '- ')
        .replace(/\n{3,}/g, '\n\n');
};
